import React from 'react'
import { Alert } from '@mui/material'
import { setDecimalPrecision } from 'utils/helpers.tsx'

interface HighBalancePaymentAlertProps {
  thresholdAmount: string
  thresholdAmountFc?: string
  paymentCurrency: string
}

const HighBalancePaymentAlert: React.FC<HighBalancePaymentAlertProps> = ({
  thresholdAmount,
  thresholdAmountFc,
  paymentCurrency,
}) => {
  const fcQualifier = thresholdAmountFc
    ? `(${setDecimalPrecision(thresholdAmountFc, { decimalPrecisionOverride: 0 })} ${paymentCurrency})`
    : ''

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {`This ticket is over the `}
      <strong>${`${setDecimalPrecision(thresholdAmount, { decimalPrecisionOverride: 0 })} ${fcQualifier}`}</strong>
      {`threshold. An administrator will need to log in to pay this ticket.`}
    </Alert>
  )
}

export default HighBalancePaymentAlert
